var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"boxShell"},[_c('i',{staticClass:"iconfont icon-chenggong-icon topicon"}),_c('p',{staticClass:"tip"},[_vm._v("验证成功")]),_c('Button',{staticClass:"nextStep",attrs:{"text":_vm.draw,"type":_vm.danger,"click":_vm.jumpTheThirdPartyAddress}})],1),_c('server-bank',{attrs:{"productId":this.$route.query.productId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }